/*
  LINE連携ポップアップの出し方（2026-10-05 デッドクリック対策）。
  theme.js の NewsletterPopup（20秒タイマー）は使わず、ここで開閉を決める。

    - 2ページ目以降の閲覧で表示（3秒後）。PCではカーソルが画面上端から出たとき（離脱時）も表示。
    - 1セッションに1回まで。
    - 閉じた人にはセクション設定「再表示までの日数」のあいだ出さない。
    - 画像・見出し・ボタンを押した人（連携に進んだ人）には365日出さない。
    - ログイン中の会員、商品・カート・会員ページは section 側で描画しないので、ここでは判定しない。

  ページ数は描画しないページも含めて数えるため、ポップアップの有無にかかわらず数える。
  theme.Modals を使うので、defer の theme.js が実行された後（DOMContentLoaded）に動かす。
*/
(() => {
  const STORE_KEY = 'lf-line-popup';
  const SESSION_SHOWN = 'lf-line-popup-shown';
  const SESSION_PAGES = 'lf-line-popup-pages';
  const DAY_MS = 864e5;
  const CLICKED_DAYS = 365;
  const SECOND_PAGE_DELAY_MS = 3000;

  // プライベートブラウズ等で storage が使えなくても、表示判定だけは動くようにする。
  const read = (area, key) => {
    try { return window[area].getItem(key); } catch (e) { return null; }
  };
  const write = (area, key, value) => {
    try { window[area].setItem(key, value); } catch (e) { /* 保存できなくても続行 */ }
  };

  const pageCount = (Number(read('sessionStorage', SESSION_PAGES)) || 0) + 1;
  write('sessionStorage', SESSION_PAGES, String(pageCount));

  const isSuppressed = () => {
    try {
      const state = JSON.parse(read('localStorage', STORE_KEY) || 'null');
      return Boolean(state && state.until > Date.now());
    } catch (e) {
      return false;
    }
  };

  const suppress = (days, reason) => {
    write('localStorage', STORE_KEY, JSON.stringify({ reason, until: Date.now() + days * DAY_MS }));
  };

  const init = () => {
    const root = document.querySelector('[data-lf-line-popup]');
    if (!root || !window.theme || typeof theme.Modals !== 'function') return;

    // テーマエディタでの開閉は theme.js の NewsletterPopup（onSelect / onDeselect）に任せる。
    if (window.Shopify && Shopify.designMode) return;

    // theme.js も同じ要素に Modal を作るが、data-test-mode="true" なので自分からは開かない。
    const modal = new theme.Modals(root.id, 'lf-line-popup-modal');
    const closedDays = Number(root.dataset.delayDays) || 5;
    let shown = false;
    let clicked = false;

    root.querySelectorAll('[data-lf-line-popup-link]').forEach((link) => {
      link.addEventListener('click', () => {
        clicked = true;
        suppress(CLICKED_DAYS, 'clicked');
      });
    });

    document.addEventListener('modalClose.' + root.id, () => {
      if (!clicked) suppress(closedDays, 'closed');
    });

    const show = () => {
      if (shown || read('sessionStorage', SESSION_SHOWN) === '1' || isSuppressed()) return;
      // カートドロワーやサイズガイドなど、別のモーダルが開いている間は割り込まない。
      if (document.documentElement.classList.contains('modal-open')) return;

      shown = true;
      write('sessionStorage', SESSION_SHOWN, '1');
      modal.open();
    };

    if (isSuppressed() || read('sessionStorage', SESSION_SHOWN) === '1') return;

    if (pageCount >= 2) {
      window.setTimeout(show, SECOND_PAGE_DELAY_MS);
    }

    // 離脱時（PCのみ。スマホには相当する操作がないため2ページ目条件だけで出す）。
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (!event.relatedTarget && event.clientY <= 0) show();
      });
    }
  };

  // defer 実行時点の readyState は 'interactive' で、theme.js はまだ実行されていない。
  // DOMContentLoaded は defer スクリプトがすべて終わった後に来るので、そこで初期化する。
  let started = false;
  const start = () => {
    if (started) return;
    started = true;
    init();
  };
  if (document.readyState === 'complete') {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
    window.addEventListener('load', start);
  }
})();
